import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import "../css/ContactSupport.css";
import { FaInstagram, FaWhatsapp, FaAt } from "react-icons/fa";

export default function ContactSupport() {
	const formRef = useRef();

	const [formData, setFormData] = useState({
		user_name: "",
		user_email: "",
		subject: "Support",
		message: "",
	});

	const [loading, setLoading] = useState(false);

	const handleChange = (e) => {
		setFormData({
			...formData,
			[e.target.name]: e.target.value,
		});
	};

	const sendEmail = async (e) => {
		e.preventDefault();

		setLoading(true);

		try {
			await emailjs.sendForm(
				"service_332v7qj",
				"template_rxnaea1",
				formRef.current,
				"6nraHe5nfZvocFHdc",
			);

			alert("Message sent successfully!");

			setFormData({
				user_name: "",
				user_email: "",
				subject: "Support",
				message: "",
			});
		} catch (error) {
			console.error(error);
			alert("Failed to send message");
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="contact-support-page">
			{/* Header */}
			<div className="support-header d-flex align-items-center justify-content-center">
				<div className="help-icon">
					<i className="far fa-question-circle"></i>
				</div>
			</div>

			{/* Hero Text */}
			<div className="support-hero">
				<h1>We're here to help!</h1>

				<p>
					Whether you're a shopper or a shop owner, reach out to us
					and our concierge team will assist you shortly.
				</p>
			</div>

			{/* Form Card */}
			<form ref={formRef} onSubmit={sendEmail} className="support-card">
				<div className="form-group-custom">
					<label>Full Name</label>

					<input
						type="text"
						name="user_name"
						value={formData.user_name}
						onChange={handleChange}
						placeholder="Alex Riviera"
						required
					/>
				</div>

				<div className="form-group-custom">
					<label>Email Address</label>

					<input
						type="email"
						name="user_email"
						value={formData.user_email}
						onChange={handleChange}
						placeholder="alex@urbanexplorer.com"
						required
					/>
				</div>

				<div className="form-group-custom">
					<label>Subject</label>

					<div className="select-wrapper">
						<select
							name="subject"
							value={formData.subject}
							onChange={handleChange}
						>
							<option>Support</option>
							<option>Technical Issue</option>
							<option>Business Inquiry</option>
						</select>

						<i className="fas fa-chevron-down"></i>
					</div>
				</div>

				<div className="form-group-custom">
					<label>Message</label>

					<textarea
						name="message"
						value={formData.message}
						onChange={handleChange}
						placeholder="How can we assist you tonight?"
						required
					/>
				</div>

				<button type="submit" className="send-btn" disabled={loading}>
					{loading ? "Sending..." : "Send Message"}
				</button>
			</form>

			{/* Contact Cards */}
			<div className="contact-info-card">
				<div className="contact-icon cyan">
					<i className="far fa-envelope"></i>
				</div>

				<h5>EMAIL US</h5>

				<p>offernova.support@gmail.com</p>
			</div>

			<div className="contact-info-card">
				<div className="contact-icon purple">
					<i className="fas fa-mobile-alt"></i>
				</div>

				<h5>CALL US</h5>

				<p>+91 8983222814</p>
			</div>

			{/* Footer */}
			<div className="stay-connected mt-3">
				<h6>STAY CONNECTED</h6>

				<div className="social-icons">
					{/* WhatsApp */}
					<a
						href="https://wa.me/918983222814?text=Hello%20I%20need%20support"
						target="_blank"
						rel="noopener noreferrer"
						className="social-btn"
					>
						<a className="social-btn" style={{ color: "#2bba2b" }}>
							<FaWhatsapp size={24} />
						</a>
					</a>

					{/* Email */}
					<a
						href="https://mail.google.com/mail/?view=cm&fs=1&to=offernova.support@gmail.com"
						target="_blank"
						rel="noopener noreferrer"
						className="social-btn"
					>
						<a className="social-btn">
							<FaAt size={24} />
						</a>
					</a>

					{/* Instagram */}
					<a
						href="https://www.instagram.com/offernova_official?igsh=b3YyNGt0bWttZnow"
						target="_blank"
						rel="noopener noreferrer"
						className="social-btn"
					>
						<a className="social-btn" style={{ color: "#e4405f" }}>
							<FaInstagram size={24} />
						</a>
					</a>
				</div>
			</div>
		</div>
	);
}
